import { Component, EventEmitter, Input, Output } from '@angular/core';
import { SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'ms-pdf-viewer',
  template: `
    <div class="pdf-viewer" (click)="close()" *ngIf="show">
      <div class="pdf-viewer-wrapper">
        <div class="pdf-viewer-header" (click)="close()">
          Cerrar <i class="fas fa-times"></i>
        </div>
        <div class="pdf-file-wrapper">
          <object
            class="pdf-file"
            *ngIf="pdfFile"
            [data]="pdfFile"
            type="application/pdf"
          >
            <p>Tu navegador no soporta PDFs</p>
          </object>
        </div>
      </div>
    </div>
  `,
  styleUrls: ['./pdf-viewer.component.scss'],
})
export class PdfViewerComponent {
  @Input() pdfFile?: SafeResourceUrl;
  @Output() pdfFileChange: EventEmitter<SafeResourceUrl> = new EventEmitter();
  @Input() show = true;
  @Output() showChange: EventEmitter<boolean> = new EventEmitter();

  close = () => {
    this.show = false;
    this.showChange.emit(this.show);
    this.pdfFile = undefined;
    this.pdfFileChange.emit(undefined);
  };
}
